<template>
  <section>
    <section-header :current="current" />
    <documento v-if="matricula" :current="current" :auto="auto" :id="matricula.matricula.idMatricula"/>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Documento from '@/components/matriculas/utilities/Documentos.vue'


export default {
  components: {
    SectionHeader, Documento
  },
  props: {
    current: Object,
    auto: Boolean
  },
  data () {
    return {
      matricula: null
    }
  },
  mounted () {
    this.$store.dispatch('matricula/get').then(response => {
      this.matricula = response
    })
  }
}
</script>

<style>

</style>